<template>
  <base-button
    @click="share()"
    type="gradient-twitter"
    icon="fa fa-twitter"
    iconOnly
    rounded
  ></base-button>
</template>

<script>
export default {
  methods: {
    share() {
      const href = "https://twitter.com/share?url=" + window.location.href;
      window.open(href, "_blank");
    }
  }
};
</script>

<style></style>
